import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { initNewRelic, newrelicAgent } from './utils/newRelic'

const browserHistory = createBrowserHistory({ basename: '' })
var reactPlugin = new ReactPlugin()

initNewRelic()

const newrelic = newrelicAgent()

const ai = new ApplicationInsights({
  config: {
    instrumentationKey: 'b943a013-a81d-4c13-9881-ab6690d1c089',
    maxBatchInterval: 0,
    disableFetchTracking: false,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: {
        history: browserHistory
      }
    }
  }
})

const trackEventFunc = (message, customData) => {
  newrelic.log(message, {customAttributes: {...customData}, level: 'INFO'})
}

const noticeErrorFunc = (message, customData) => {
  newrelic.noticeError(message, {customAttributes: {...customData}})
  newrelic.log(message, {customAttributes: {...customData}, level: 'ERROR'})
}

ai.loadAppInsights()

export default (Component) => withAITracking(reactPlugin, Component)
export const appInsights = ai.appInsights
export const trackEvent = trackEventFunc
export const noticeError = noticeErrorFunc
export const newRelic = newrelic
